var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold px-2",attrs:{"label":"","x-small":"","color":_vm.color,"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }